export interface ApiResponseList<T> {
    entities: T[];
    total: number;
}

export class ApiHelper {
    public static normalize(payload, instanceObj) {
        const intersect = this.intersect.bind(new instanceObj);

        return Array.isArray(payload) ? payload.map(intersect) : intersect(payload);
    }

    /**
     * Removes properties than not exist as default for passed instance;
     * @param sourceObj
     */
    private static intersect(sourceObj: any) {
        for(const keyName of Object.keys(this)) {
            if(sourceObj && sourceObj.hasOwnProperty(keyName)) {
                switch (typeof this[keyName]) {
                    case 'string':
                        this[keyName] = sourceObj[keyName] || '';
                        break;

                    case 'number':
                        this[keyName] = +sourceObj[keyName];
                        break;

                    case 'boolean':
                        this[keyName] = !!sourceObj[keyName];
                        break;

                    default:
                        this[keyName] = sourceObj[keyName];
                }
            } else {
                delete this[keyName];
            }
        }

        return this;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/api-response/helpers.ts